import Promotion from 'common/modules/sales/domain/SalesPromotion';
import {
  CREATE_NEW_PROMOTION,
  CREATE_NEW_PROMOTION_ERROR,
  CREATE_NEW_PROMOTION_SUCCESS,
  FETCH_PROMOTIONS,
  FETCH_PROMOTIONS_SUCCESS,
  FETCH_PROMOTIONS_FAILED,
} from '../actions/promotionActions';

export type PromotionState = {
  creating: ?boolean;
  creatingError: ?Object;
  promotions: Promotion[];
  fetching: boolean;
  fetchingError: ?Object;
}

export const INITIAL_STATE = {
  creating: false,
  creatingError: undefined,
  promotions: [],
  fetching: false,
  fetchingError: undefined,
};

const promotionReducer = (state: PromotionState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case CREATE_NEW_PROMOTION:
      return {
        ...state,
        creatingError: undefined,
        creating: true,
      };
    case CREATE_NEW_PROMOTION_SUCCESS: {
      const promotions = state.promotions.slice();
      promotions.push(action.promotion);

      return {
        ...state,
        creating: false,
        promotions,
      };
    }
    case CREATE_NEW_PROMOTION_ERROR:
      return {
        ...state,
        creating: false,
        creatingError: action.error,
      };
    case FETCH_PROMOTIONS:
      return {
        ...state,
        fetchingError: undefined,
        fetching: true,
      };
    case FETCH_PROMOTIONS_SUCCESS:
      return {
        ...state,
        promotions: action.promotions,
        fetching: false,
      };
    case FETCH_PROMOTIONS_FAILED:
      return {
        ...state,
        fetching: false,
        fetchingError: action.error,
      };
    default:
      return state;
  }
};

export default promotionReducer;



// WEBPACK FOOTER //
// ./src/statsradio/modules/promotions/reducers/promotionReducer.js